import { FC, PropsWithChildren } from "react";
import styles from "./Inline.module.css";

const Inline: FC<PropsWithChildren> = ({ children }) => <div className={styles.inline}>{children}</div>;

export default Inline;
